// pages/Edit.tsx
import React from 'react';
import { useForm } from 'react-hook-form';
import CrudEdit from '~/components/CrudEdit';
import IMaterialGroup from '../interfaces/IMaterialGroup';

export default function Edit() {
  const { register, handleSubmit, control, setValue: setFormValue, getValues } = useForm<IMaterialGroup>();
  const fields = [
    { name: 'id', type: 'hidden' },
    { name: 'name', type: 'string' },
  ];

  return (
    <CrudEdit
      model={'material-group'}
      fields={fields}
      register={register}
      handleSubmit={handleSubmit}
      control={control}
      setFormValue={setFormValue}
      messageSuccess={'Material group successfully updated!'}
      title={'Edit material group'}
      getValues={getValues}
    />
  );
}